import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Table } from 'primeng/table';
import { ViewComponent } from 'src/app/core/view/view.component';
import { ViewsService } from 'src/app/core/view/views.service';
import { MailingDetailComponent } from 'src/app/mailing/mailing-detail/mailing-detail.component';
import { NotificationsService } from 'src/app/notifications/notifications.service';
import { MailchimpService } from '../../configuration/integration/mailchimp.service';
import { CoreDialogService } from '../../core/dialogs/core-dialog.service';
import { MailMarketingSendComponent } from '../mail-marketing-send/mail-marketing-send.component';
import { MailMarketingTestComponent } from '../mail-marketing-test/mail-marketing-test.component';

@Component({
  selector: 'app-mail-marketing-list',
  templateUrl: './mail-marketing-list.component.html',
  styleUrls: ['./mail-marketing-list.component.scss']
})
export class MailMarketingListComponent implements OnInit {
  @ViewChild("view") public view: ViewComponent;
  @ViewChild("grid") public grid: Table;
  public notificationsEmails: any[];
  public totalRecords: number;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {};
  public status = [];

  constructor(
    private router: Router,
    private messageService: MessageService,
    private notificationsService: NotificationsService,
    private dialogService: DialogService,
    private coreDialogService: CoreDialogService,
    private viewsService: ViewsService,
    private mailchimpService: MailchimpService
  ) { }

  ngOnInit(): void {
    this.status = [{ label: "Enviado", value: "sent" }, { label: "Error", value: "error" }, { label: "Pendiente", value: "pending" }, { label: "Programado", value: "programmed" }];

  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  loadData($event) {
    this.lastGridEvent = $event;
    Promise.resolve(null).then(() => this.loading = true);
    var params = {
      _page: $event.first / $event.rows,
      _pageSize: $event.rows,
      _sortBy: $event.sortField ? $event.sortField : "",
      _sortDirection: $event.sortOrder > 0 ? "asc" : "desc"
    };
    console.log(this.filters);

    params = Object.assign(params, this.filters);
    console.log(params);

    this.notificationsService.all(params).subscribe(
      data => {
        this.totalRecords = data.totalRows;
        this.notificationsEmails = data.rows;
        Promise.resolve(null).then(() => this.loading = false);
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        Promise.resolve(null).then(() => this.loading = false);
      }
    )
  }

  sendTest(id: number) {
    const ref = this.dialogService.open(MailMarketingTestComponent, {
      data: {
        notificationId: id
      },
      header: "Enviar email de prueba",
      width: "30%",
      /*baseZIndex: 1000*/
    });
    ref.onClose.subscribe((data: any) => {
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
      this.search();
    });
  }

  send(id: number) {

    const ref = this.dialogService.open(MailMarketingSendComponent, {
      data: {
        notificationId: id
      },
      header: "Enviar mail marketing",
      width: "20%",
    });
    ref.onClose.subscribe((data: any) => {
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
      this.search();
    });

  }
  duplicateAndSend(id: number) {
    //Duplicamos la líneas de notification_to y notification_email.
    this.notificationsService.duplicateMail(id).subscribe(
      data => {
        const ref = this.dialogService.open(MailMarketingSendComponent, {
          data: {
            notificationId: data
          },
          header: "Enviar mail marketing",
          width: "20%",
        });
        ref.onClose.subscribe((data: any) => {
          if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
          this.search();
        });
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      });
  }

  cancelMail(id: number) {
    this.notificationsService.cancelMail(id).subscribe(
      data => {
        this.search();
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    )
  }

  getType(type) {
    if (type == 'mailchimp') {
      //return "<div class='badge badge-block badge-success'>MAILCHIMP</div>";
      return "<img src='/assets/img/integrations/mailchimp.png' height='16' />";
    } else if (type == "mailjet") {
      //return "<div class='badge badge-block badge-success'>MAILJET</div>";
      return "<img src='/assets/img/integrations/mailjet.png' height='16' />";
    } else if (type == "mail_marketing") {
      //return "<div class='badge badge-block badge-success'>ESTANDAR</div>";
      //return "<img src='/assets/img/integrations/apirest.png' height='16' />";
      return "<div>SMTP</div>";
    }
  }

  getstatus(status) {
    if (status == 'sent') {
      return "<div class='badge badge-block badge-success'>Enviado</div>";
    } else if (status == "pending") {
      return "<div class='badge badge-block badge-warning'>Enviando</div>";
    } else if (status == "waiting") {
      return "<div class='badge badge-block badge-warning'>En espera</div>";
    } else if (status == "programmed") {
      return "<div class='badge badge-block badge-info'>Programado</div>";
    } else if (status == "error") {
      return "<div class='badge badge-block badge-danger'>Error</div>";
    } else {
      return "<div class='badge badge-block badge-secondary'>Pendientes</div>";
    }
  }

  viewMail(data) {
    const ref = this.dialogService.open(MailingDetailComponent, {
      data: {
        mail_id: data.id,
        //entity_id: data.notificationEmails.entity.id,
        //template_type_id: 1,
        template_type_code: "MAIL",
        searchRelated: true
      },
      header: "Mensaje de correo",
      width: '70%',
    });
  };

  mailchimpDashboard(data) {
    this.mailchimpService.dashboard(data.id).subscribe(
      (data:any) => {
        if (data.success) {
          window.open(data.url);
        } else {
          this.messageService.add({ closable: false, severity: "error", detail: data.message });
        }
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    )
  };

  delete(id) {
    this.coreDialogService.confirm({
      message: '¿Está seguro de querer borrar mail marketing? ',
      accept: () => {
        this.notificationsService.delete(id).subscribe(res => {
          this.messageService.add({ severity: 'success', summary: 'Elemento eliminado correctamente' });
          this.search();
        }, error => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error.title });
        });
      },
      reject: () => {
      }
    });
  }

}
